<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Edit Audit">
      <v-card-actions>
        <a @click="$router.back()">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
            class="mr-n2 mt-10" style="opacity:.6;">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component v-if="!editData">
        <p class="text-center">No Data Found</p>
      </v-card-component>
      <v-card-component v-if="!isEditable">
        <p class="text-center">This Audit is not editable</p>
      </v-card-component>
      <v-card-component v-if="editData && isEditable">
        <v-progress-linear :value="percentage" color="#5d58ef" height="10">
          <strong class="percentage">{{ Math.ceil(percentage) }}%</strong>
        </v-progress-linear>
        <form autocomplete="off" @submit.prevent="save">
          <v-row>
            <!-- <v-col cols="12" sm="4">
              <v-text-field label="Title" v-model="formData.auditTitle" color="#5d58ef">
              </v-text-field>
            </v-col> -->
            <v-col cols="12" md="3">
              <v-autocomplete label="Select acadamic year" clearable disabled
                v-model="formData.academicYearID" :items="acadamicYearData"
                v-on:change="getTeacherList();getClassList()" key="id" item-value="id"
                item-text="academicYear">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete label="Center" clearable v-model="formData.franchiseeID"
                :items="centreList" v-on:change="getTeacherList();getClassList()" key="id"
                item-value="id" disabled item-text="companyName">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete label="Teacher" clearable v-model="formData.auditeeID"
                :items="teacherList" disabled key="user.id" item-value="user.id"
                item-text="user.firstName">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete label="Select Class" clearable v-model="formData.classID"
                :items="classList" disabled v-on:change="getCategories()" key="id" item-value="id"
                item-text="name">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-menu disabled ref="menu1" v-model="menu1" :close-on-content-click="false"
                transition="scale-transition" offset-y max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field disabled v-model="formData.auditDate" label="Select Date"
                    persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker disabled v-model="date" no-title @input="menu1 = false">
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" md="3">
              <v-autocomplete label="Type *" disabled clearable v-model="formData.type"
                :items="typeOptions">
              </v-autocomplete>
            </v-col>
          </v-row>
          <!--+++++++++++++++++++++++++++Category Fields Start++++++++++++++++++++++++++++++++++++++++++-->
          <v-container v-for="item in categoryData" :key="item.id">
            <v-row>
              <v-col>
                <p class="mb-0 mt-5" style="width: 100%;">
                  <strong class="header-title ml-3">
                    <v-icon>mdi-checkbox-marked</v-icon> {{item.categoryName}}
                  </strong>
                </p>
              </v-col>
              <v-col cols="12" md="3">
                <!-- {{item.score}} -->
                <!-- <v-autocomplete label="Select Score" clearable v-model="item.score"
                    :items="scoreList" v-on:change="getTeacherList()" key="id" item-value="value"
                    item-text="value">
                  </v-autocomplete> -->
              </v-col>
            </v-row>
            <!-- <v-divider class="my-0 hr-divider" /> -->
            <v-data-table :headers="headers" :items="item.acadAuditParameterMaps" disable-pagination
              hide-default-footer>
              <template v-slot:item.score="{item}">
                <v-autocomplete label="Select Score" clearable v-model="item.score"
                  v-on:change="formProgressCaluculation()" :items="scoreList" key="id"
                  item-value="value" item-text="label"> </v-autocomplete>
              </template>
            </v-data-table>
            <v-col class="pl-0 pr-0" cols="12">
              <v-text-field v-on:change="formProgressCaluculation()" v-model="item.remark"
                label="Remarks" color="#5d58ef" outlined>
              </v-text-field>
            </v-col>
          </v-container>
          <!--+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
          <v-col class="pl-0 pr-0" cols="12">
            <v-text-field v-model="formData.overallRemark" label="Overall Remarks" color="#5d58ef"
              outlined>
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-card-actions class="d-flex justify-end">
              <v-btn bottom @click="saveAsDraft" right elevation="1" color="primary" type="button">
                <v-icon left> mdi-content-save </v-icon>
                Save as draft
              </v-btn>
              <v-btn bottom right elevation="1" color="primary" type="submit">
                <v-icon left>mdi-clipboard-edit-outline </v-icon>
                Submit
              </v-btn>
            </v-card-actions>
          </v-col>

        </form>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import { mapGetters } from 'vuex'
import _ from 'lodash'
// import stores from '@/stores'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import moment from 'moment'

export default {
  components: { VCardComponent, MaterialCard },
  props: ['id'],
  data () {
    return {
      percentage: 0,
      editData: null,
      centreList: [],
      classList: [],
      teacherList: [],
      isLoading: false,
      isEditable: true,
      categoryData: [],
      acadamicYearData: [],
      typeOptions: ['online', 'offline'],
      scoreList: [],
      formData: {
        auditDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        overallRemark: '',
        academicYearID: '',
        classID: '',
        auditeeID: '',
        franchiseeID: ''
      },
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu1: false,
      noOfFields: 0,
      headers: [
        { text: 'Parameter', value: 'parameter', sortable: false, width: '70%' },
        { text: 'Score', value: 'score', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    formData: {
      handler: function () {
        this.formProgressCaluculation()
      },
      deep: true
    },
    academicYear: function (val) {
      if (val) {
        console.log('____Academic ID____', val.academicYear)
        // this.formData.academicYearID = val.id
        this.getTeacherList()
      }
    }
  },
  created: async function () {
    this.formProgressInit()
    await this.getAcadById()
  },
  methods: {
    async save () {
      try {
        let progressCalc = this.formProgressCaluculation()
        if (progressCalc) {
          let parameter = []
          let category = this.categoryData.map((item) => {
            parameter = item.acadAuditParameterMaps.map((ele) => {
              return {
                id: ele.id,
                // parameterID: ele.id,
                // parameter: ele.name,
                score: ele.score
              }
            })
            return {
              id: item.id,
              // categoryID: item.acadAuditCategory.id,
              // categoryName: item.name,
              // score: item.score,
              remark: item.remark || '',
              parameter: parameter
            }
          })
          let obj = {
            category: category,
            // academicYearID: this.formData.academicYearID,
            // classID: this.formData.classID,
            // auditeeID: this.formData.auditeeID,
            // franchiseeID: this.formData.franchiseeID,
            // auditedBy: stores.user.me.id,
            // auditTitle: this.formData.auditTitle,
            auditDate: this.formData.auditDate,
            isPublish: true,
            overallRemark: this.formData.overallRemark
            // status: 'NA'
            // isActive: true
          }
          console.log('___Request___', obj)
          let res = await http.put(`${CONSTANTS.API_URL}/api/center-audit/audit/${this.id}`, obj)
          this.okMsg(res.data)
          this.$router.push({ name: 'acadAudits', params: { type: 'online' } })
        } else {
          this.errMsg('Please fill all the score fields.')
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    async saveAsDraft () {
      try {
        console.log('____Save____')
        if (this.draftValidation()) {
          let parameter = []
          let category = this.categoryData.map((item) => {
            parameter = item.acadAuditParameterMaps.map((ele) => {
              return {
                id: ele.id,
                // parameterID: ele.id,
                // parameter: ele.name,
                score: ele.score
              }
            })
            return {
              id: item.id,
              // categoryID: item.acadAuditCategory.id,
              // categoryName: item.name,
              // score: item.score,
              remark: item.remark || '',
              parameter: parameter
            }
          })
          let obj = {
            category: category,
            // academicYearID: this.formData.academicYearID,
            // classID: this.formData.classID,
            // auditeeID: this.formData.auditeeID,
            // franchiseeID: this.formData.franchiseeID,
            // auditedBy: stores.user.me.id,
            // auditTitle: this.formData.auditTitle,
            auditDate: this.formData.auditDate,
            isPublish: false,
            overallRemark: this.formData.overallRemark
            // status: 'NA'
            // isActive: true
          }
          console.log('___Request___', obj)
          let res = await http.put(`${CONSTANTS.API_URL}/api/center-audit/audit/${this.id}`, obj)
          console.log('___Response___', res.data)
          this.okMsg(res.data)
          this.$router.push({ name: 'acadAudits', params: { type: 'online' } })
        } else {
          this.errMsg('Please fill all the fields.')
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    draftValidation () {
      let message = ''

      return message === ''
    },
    getAcadById: async function (id = '') {
      let rows = await http.get(`${CONSTANTS.API_URL}/api/center-audit/audit/${this.id}`)
      console.log('____ACad by ID__', rows.data)
      this.editData = rows.data
      console.log(`____Allow Update ? => ${this.editData.isPublish}`)
      this.isEditable = !this.editData.isPublish
      /**
       * auditDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        overallRemark: '',
        academicYearID: '',
        classID: '',
        auditeeID: '',
        franchiseeID: '',
        auditTitle: '',
        status: 'NA'
       */
      // Patching the previous values
      // this.formData.auditTitle = this.editData.auditTitle
      this.formData.auditDate = moment(new Date(this.editData.auditDate)).format('YYYY-MM-DD')
      this.formData.overallRemark = this.editData.overallRemark
      this.formData.auditeeID = this.editData.auditeeID
      this.formData.academicYearID = this.editData.academicYearID
      this.formData.classID = this.editData.classID
      this.formData.franchiseeID = this.editData.franchiseeID
      this.formData.type = this.editData.type
      await this.getFranchisee()
      // let parameters = []
      // this.editData.acadAuditCategoryMaps.map((data) => {
      //   parameters = parameters.concat(data.acadAuditParameterMaps)
      // })
      console.log('___Fetch Data')
      console.log(this.editData.acadAuditCategoryMaps)

      // Sorting category array based on position
      this.editData.acadAuditCategoryMaps = _.orderBy(this.editData.acadAuditCategoryMaps, ['position'], ['asc'])

      // Sorting parameter array based on position
      this.editData.acadAuditCategoryMaps.map((item) => {
        item.acadAuditParameterMaps = _.orderBy(item.acadAuditParameterMaps, ['position'], ['asc'])
      })
      this.categoryData = this.editData.acadAuditCategoryMaps
      // await this.getCategories(parameters, this.editData.acadAuditCategoryMaps)
      await this.getAcadamicYearsList()
      await this.getScoreList()
      await this.getClassList()
      await this.getTeacherList()
    },
    async getScoreList () {
      let rows = await http.get(`${CONSTANTS.API_URL}/api/center-audit/score/points`)
      this.scoreList = rows.data.map((item) => {
        item.label = parseInt(item.value) === 0 ? 'NA' : item.value
        return item
      })
    },
    async getTeacherList () {
      this.formData.academicYearID = this.academicYear.id
      if (this.formData.franchiseeID && this.formData.academicYearID) {
        // staff/teacher-class-map
        let rows = await http.get(`${CONSTANTS.API_URL}/api/staff/approved`, {
          params: {
            franchiseeID: this.formData.franchiseeID,
            isTeachingStaff: true
          }
        })
        // console.log('____Teacher list___', rows.data)
        this.teacherList = rows.data
        this.getClassList()
      }
    },
    async getClassList () {
      this.formData.academicYearID = this.academicYear.id
      if (this.formData.franchiseeID && this.formData.academicYearID) {
        let rows = await http.get(`${CONSTANTS.API_URL}/api/student/get-all-classby-franchisee`, {
          params: {
            franchiseeID: this.formData.franchiseeID,
            academicYearID: this.formData.academicYearID
          }
        })
        // console.log('___Class List___', rows.data)
        this.classList = rows.data
      }
    },
    formProgressInit () {
      this.noOfFields = Object.keys(this.formData).length
      this.categoryData.forEach((element) => {
        element.acadAuditParameters = element.acadAuditCategory.acadAuditParameters.map((item) => {
          // item.score = 'NA'
          console.log('____SCORE: ' + item.score)
          this.noOfFields++
          return item
        })
      })
      this.noOfFields += this.categoryData.length
    },
    formProgressCaluculation () {
      let invalidFieldCount = 0
      Object.keys(this.formData).map((key) => {
        if (key !== 'overallRemark') {
          if (!this.formData[key]) {
            invalidFieldCount++
          }
        }
      })
      this.categoryData.forEach((element) => {
        // Remark field is made optional
        // if (!element.remark) {
        //   invalidFieldCount++
        // }

        element.acadAuditParameterMaps.map((item) => {
          if (!item.score) {
            invalidFieldCount++
          }
        })
      })
      let filledFields = this.noOfFields - invalidFieldCount
      this.percentage = (filledFields / this.noOfFields) * 100
      // console.log('Total Fields: ', this.noOfFields)
      // console.log('Invalid Fields: ', invalidFieldCount)
      // console.log('Filled Fields: ', filledFields)
      // console.log('Percentage: ', this.percentage)
      return this.noOfFields === filledFields
    },
    getCategories: async function (parameters = [], category = []) {
      try {
        if (this.formData.classID && this.formData.academicYearID) {
          let rows = await http.get(`${CONSTANTS.API_URL}/api/center-audit/category/classes`, {
            params: {
              classID: this.formData.classID,
              academicYearID: this.formData.academicYearID,
              type: this.editData.type
            }
          })
          this.categoryData = rows.data
          let flagIndexes = []
          this.categoryData = this.categoryData.map((item, index) => {
            item.name = item.acadAuditCategory.name
            let flag = false
            category.forEach((cat) => {
              if (cat.categoryID === item.categoryID) {
                flag = true
                item.remark = cat.remark
                item.updateId = cat.id
              }
            })
            if (!flag) {
              flagIndexes.push(index)
            }

            item.acadAuditParameters = item.acadAuditCategory.acadAuditParameters.map((ele) => {
              parameters.forEach((param) => {
                if (param.parameterID === ele.id) {
                  // Previous entry found patching it
                  ele.updateId = param.id
                  ele.score = param.score
                }
              })
              if (!ele.score) {
                ele.score = 'NA'
              }
              return ele
            })
            return item
          })
          flagIndexes.forEach((index) => {
            // Deleting the newly added categories
            this.categoryData.splice(index, 1)
          })
          // let parameters = []
          // this.editData.acadAuditCategoryMaps.map((data) => {
          //   parameters = parameters.concat(data.acadAuditParameterMaps)
          // })
          // console.log('___Fetch Data')
          // console.log(this.editData.acadAuditCategoryMaps)
          // await this.getCategories(parameters, this.editData.acadAuditCategoryMaps)
          console.log('Category Data', this.categoryData)

          this.formProgressInit()
          this.formProgressCaluculation()
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    getFranchisee: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/franchisee`)
        this.centreList = res.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    getAcadamicYearsList: async function () {
      let rows = await http.get(`${CONSTANTS.API_URL}/api/franchiseeAcademicYears`)
      this.acadamicYearData = rows.data.rows
      // console.log('___Acad Years__', this.acadamicYearData)
    }
  }
}
</script>

<style scoped>
.header-title {
  font-size: 16px;
  color: dimgray;
}
.hr-divider {
  border: solid white;
  border-bottom: solid 3px rgba(0, 0, 0, 0.42);
}
.theme--light.v-sheet--outlined {
  border: none !important;
}
.percentage {
  color: #fff;
  font-size: 9px;
}
</style>
